import React from "react";
import { Logo } from "./logo/Logo";
import Menu from "./menu/Menu";
import s from "./style.module.css";

export default function Header({ bigScreen }) {
  return (
    <div className={`${bigScreen ? s.containerLarge : "container"}`}>
      <div className={`row pt-3`}>
        <div className="col-6 col-md-2 d-flex justify-content-start align-items-center">
          <Logo />
        </div>
        <div className="col-6 col-md-10 d-flex justify-content-end align-items-center">
          <Menu />
        </div>
      </div>
    </div>
  );
}
